import api from './api';

export type IPostVacancyResponsePayload = {
  firstName: string;
  lastName: string;
  patronymic: string;
  birthdate: string;
  phoneNumber: string;
  telegram: string;
  email: string;
  currentWorkplace: string;
  currentJob: string;
  expectedSalary: string;
  coverLetter: string;
  cvFile: File;
  checkPersonalData: boolean;
  checkIT: boolean;
  recommendation: string | null | undefined;
  division: string | null;
  vacancy: string | null;
};

function formatDate(dateStr: string) {
  const [dd, MM, YYYY] = dateStr.split('.');
  return new Date(`${YYYY}-${MM}-${dd}T00:00:00.000Z`).toJSON();
}

async function postVacancyResponseAPI(data: IPostVacancyResponsePayload) {
  const formData = new FormData();
  formData.append('last_name', data.lastName);
  formData.append('first_name', data.firstName);
  if (data.patronymic) {
    formData.append('patronymic', data.patronymic);
  }

  formData.append('birthdate', formatDate(data.birthdate));
  formData.append('phone_number', data.phoneNumber);
  if (data.telegram) {
    formData.append('telegram', data.telegram);
  }
  formData.append('email', data.email);
  formData.append('current_workplace', data.currentWorkplace);
  formData.append('current_job', data.currentJob);
  if (data.expectedSalary) {
    formData.append('expected_salary', data.expectedSalary);
  }
  if (data.coverLetter) {
    formData.append('cover_letter', data.coverLetter);
  }
  formData.append('file', data.cvFile);
  if (data.vacancy) {
    formData.append('vacancy', data.vacancy);
  }
  if (data.division) {
    formData.append('division', data.division);
  }
  formData.append('check_PD', String(data.checkPersonalData));
  formData.append('check_IT', String(data.checkIT));
  if (data.recommendation) {
    formData.append('recommendation', data.recommendation);
  }
  return api.post('/vacancy_response/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
}

export default postVacancyResponseAPI;
